"use client";
import styles from './Footer.module.scss';
import logo from '../../../../public/footerLogo.svg';
import logo1 from '../../../../public/Brand-logo.svg';
import classNames from 'classnames';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import linkdn from '../../../../public/Landing/linkdn.svg';
import { ROUTES } from '@/lib/routes';


const Footer = () => {

  const pathname = usePathname();
 
  if (
    pathname.startsWith("/registration") || 
    pathname.startsWith("/testimonial") || 
    pathname.startsWith("/mobile-responsive") ||
    pathname.startsWith("/pricing")
  ) {
  return null;
}


  return (
    <footer>
      <div className={classNames(styles.container, 'padding-left', 'padding-right')} style={{ minHeight: pathname === '/' ? '280px' : '80px' }}>
        <div>
          {
            pathname === '/' ? (
              <>
                <div className={classNames(styles.landingLogo, 'primary_font')}>
                  <Image src={logo1} alt='' />
                  <p className={classNames(styles.landingLogoTitle)}>Your Personal Brand is Your Power - Amplify Your Career Journey <br />
                    With Candidate Review!</p>
                  <p className={classNames(styles.landingLogoCopy,'not-visible')} >Copyright &copy; 2025 Candidate Review</p>
                </div>

                <div className={classNames(styles.footerLanding,styles.responsiveFooterLanding, 'primary_font', 'primary_text_color','visible')}>
                  <p className={classNames(styles.landingTitle)}>Connect with us on LinkedIn</p>
                  <Image src={linkdn} alt=''className={classNames(styles.responsiveLinkden)}/>
                  <p className={classNames(styles.landingEmail)}><a href="mailto:hello@candidatereview.ai">hello@candidatereview.ai</a></p>
                  <p className={classNames(styles.landingTerm,styles.responsiveterm)} ><Link href='/terms-of-use'>Terms of Use</Link></p>
                  <p className={classNames(styles.landingLogoCopy)} >Copyright &copy; 2025 Candidate Review</p>
                  <p style={{marginTop:"-15px"}}className={classNames(styles.landingTerm,styles.responsiveterm)} >v.1.0.0</p>
                </div>
              </>


            ) : (
              <Image src={logo} alt='' width={42} height={53} priority />
            )
          }
        </div>

        {
          pathname === '/' ? (
            <div className={classNames(styles.footerLanding, 'primary_font', 'primary_text_color','not-visible')}>
              <p className={classNames(styles.landingTitle)}>Connect with us on LinkedIn</p>
              <Image src={linkdn} alt='' />
              <p className={classNames(styles.landingEmail)}><a href="mailto:hello@candidatereview.ai">hello@candidatereview.ai</a></p>
              <p className={classNames(styles.landingTerm)} ><Link href={ROUTES.TERMS_OF_USE}>Terms of Use</Link></p>
              <p style={{marginTop:"-10px"}} className={classNames(styles.landingTerm)} >v.1.0.0</p>
            </div>

          ) : (
            <div className={classNames(styles.footerText)}>
              <p className={classNames('primary_font', 'primary_text_color')} >Candidate Review &copy; 2025</p>
              <p className={classNames('grey_text_color')} ><Link  href={ROUTES.TERMS_OF_USE}>Terms of Use</Link></p>
              <p className={classNames('grey_text_color')} >v.1.0.0</p>
            </div>
          )
        }

      </div>

    </footer>

  );
};

export default Footer;